/**
 * The one condition of GeoNames' CC BY 4.0 licence (web plan W0.19, master
 * plan 6e): the backend's countries, boundaries and cities are seeded from the
 * GeoNames download and then edited, hence "modified". Shown in the footer on
 * every page and repeated on the About page (web plan W3.7). Keep the wording
 * and both links as they are: it is a licence notice, not UI copy, so it stays
 * this fixed English text.
 */

/** The attribution's two links: the source and the licence. */
export const GEONAMES_URL = 'https://www.geonames.org';
export const CC_BY_4_URL = 'https://creativecommons.org/licenses/by/4.0/';

const LINK = 'underline transition-colors duration-200 hover:text-primary-strong';

export function GeoNamesAttribution({ className }: { className?: string }) {
  return (
    <p className={className}>
      Place data from GeoNames (
      <a href={GEONAMES_URL} className={LINK}>
        geonames.org
      </a>
      ),{' '}
      <a href={CC_BY_4_URL} className={LINK}>
        CC BY 4.0
      </a>
      , modified
    </p>
  );
}

export default GeoNamesAttribution;
